import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const message = this.state.error?.message ?? 'Une erreur inattendue est survenue';

    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-bg p-6">
        <div className="max-w-md w-full rounded-lg border border-border-light bg-surface-white p-8 shadow-lg">
          <div className="mb-4 text-2xl text-status-urgent-text">⚠</div>
          <h1 className="text-lg font-semibold text-text-primary mb-2">
            KTM Atelier Board — Erreur
          </h1>
          <p className="text-sm text-text-muted mb-6">
            L'écran a rencontré un problème. Recharger la page suffit dans la plupart des cas.
          </p>
          <pre className="text-xs font-mono bg-surface-bg border border-border-light rounded p-3 mb-6 overflow-auto max-h-40 text-text-muted whitespace-pre-wrap">
            {message}
          </pre>
          <div className="flex gap-2">
            <button
              onClick={this.handleReload}
              className="flex-1 rounded bg-ktm-orange text-text-on-orange text-sm font-medium py-2 hover:bg-ktm-orange-hover transition"
            >
              Recharger
            </button>
            <button
              onClick={this.handleHome}
              className="flex-1 rounded border border-border-light text-text-primary text-sm font-medium py-2 hover:bg-surface-hover transition"
            >
              Accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}
